import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const [user, loading] = useAuthState(auth);

  if (loading)
    return (
      <div className="auth-wrap">
        <p className="font-pixel text-sm">loading<span className="blink">_</span></p>
      </div>
    );
  if (!user) return <Navigate to="/signin" replace />;

  return children;
}
